export default __webpack_public_path__ + "static/media/checkoutmunchen.f1bc8e9a.svg";